module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-48x48-059bcff5ecd8d7585eb31e6ae51770cd.png";